var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 189,
    viewBox: "0 0 264 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.736 142.934L218.836 186.731C218.82 186.954 218.721 187.162 218.558 187.314C218.395 187.467 218.18 187.552 217.957 187.553C217.839 187.553 217.723 187.53 217.615 187.484C217.507 187.438 217.409 187.371 217.328 187.286C217.246 187.202 217.183 187.102 217.141 186.992C217.099 186.882 217.079 186.766 217.084 186.648L218.275 142.934H221.736Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.155 142.934L232.055 186.731C232.07 186.953 232.168 187.161 232.33 187.314C232.492 187.467 232.706 187.552 232.928 187.553C233.046 187.553 233.162 187.53 233.271 187.484C233.379 187.438 233.477 187.371 233.559 187.287C233.641 187.202 233.706 187.102 233.748 186.993C233.791 186.883 233.811 186.766 233.808 186.648L232.603 142.96L229.155 142.934Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.08 142.934L202.98 186.731C202.994 186.953 203.093 187.161 203.255 187.314C203.417 187.467 203.63 187.552 203.853 187.553C203.971 187.553 204.087 187.53 204.196 187.484C204.304 187.438 204.402 187.371 204.484 187.287C204.566 187.202 204.63 187.102 204.673 186.993C204.716 186.883 204.736 186.766 204.733 186.648L203.522 142.96L200.08 142.934Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.233 142.934L185.333 186.731C185.317 186.954 185.218 187.162 185.055 187.314C184.892 187.467 184.677 187.552 184.454 187.553C184.337 187.552 184.22 187.528 184.112 187.482C184.004 187.436 183.907 187.369 183.825 187.285C183.743 187.201 183.679 187.101 183.636 186.992C183.593 186.882 183.572 186.766 183.574 186.648L184.785 142.96L188.233 142.934Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238.753 98.7807C238.753 98.7807 209.819 97.6973 207.372 97.6973C204.924 97.6973 204.357 98.7807 204.357 98.7807L200.227 127.9C200.227 127.9 187.385 124.235 184.868 124.713C182.35 125.191 186.111 143.463 186.111 143.463H200.642L200.903 142.367H233.712L242.424 100.865C241.895 98.9655 238.753 98.7807 238.753 98.7807Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.741 116.995C227.741 116.995 230.685 136.115 227.308 138.346C226.785 138.69 223.949 140.321 221.298 140.054C219.169 139.837 204.128 140.054 204.128 140.054C204.128 140.054 202.038 136.077 201.617 133.145C201.197 130.213 204.485 117.633 204.485 117.633L227.741 116.995Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.108 127.237C203.108 127.237 181.337 129.5 180.311 130.111C179.285 130.723 174.575 134.834 175.384 137.504C176.194 140.175 174.154 140.379 176.021 140.793C177.889 141.207 204.357 141.201 204.357 141.201",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.108 127.237C203.108 127.237 181.337 129.5 180.311 130.111C179.285 130.723 174.575 134.834 175.384 137.504C176.194 140.175 174.154 140.379 176.021 140.793C177.889 141.207 204.357 141.201 204.357 141.201",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.306 143.432H235.037V139.569H183.306V143.432Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222.82 128.059H191.655C191.655 128.059 190.017 129.908 189.807 133.795C189.597 137.683 190.017 138.518 192.892 139.531C195.766 140.545 221.297 140.028 221.297 140.028",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M222.82 128.059H191.655C191.655 128.059 190.017 129.908 189.807 133.795C189.597 137.683 190.017 138.518 192.892 139.531C195.766 140.545 221.297 140.028 221.297 140.028",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.264 177.516L195.001 169.785L189.654 170.798L193.746 177.694L191.388 182.417L186.289 185.75C186.289 185.75 185.697 186.336 188.246 186.139C190.795 185.941 196.085 186.139 196.085 186.139L199.418 182.219C199.418 182.219 200.629 180.224 198.264 177.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.692 180.893L199.826 185.947H199.029L197.965 183.423L199.692 180.893Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.091 186.164L199.424 182.244C199.424 182.244 200.284 180.785 199.099 178.682C196.728 182.735 193.573 183.952 193.573 183.952L190.285 183.162L186.295 185.775C186.295 185.775 185.702 186.361 188.252 186.164C190.801 185.966 196.091 186.164 196.091 186.164Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.448 138.122L196.378 171.168L188.622 172.544L173.326 138.129C173.326 138.129 172.096 132.992 175.379 131.354C178.661 129.716 188.316 128.888 188.316 128.888",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M185.448 138.122L196.378 171.168L188.622 172.544L173.326 138.129C173.326 138.129 172.096 132.992 175.379 131.354C178.661 129.716 188.316 128.888 188.316 128.888",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.507 143.425C220.507 143.425 216.74 125.128 219.264 124.675C221.788 124.223 234.624 127.862 234.624 127.862L238.753 98.7807C238.753 98.7807 243.113 98.0924 243.572 101.967C244.03 105.842 235.038 143.425 235.038 143.425H220.507Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.155 89.5524L174.211 86.3658C174.024 86.0605 173.76 85.8095 173.446 85.6373C173.132 85.4652 172.779 85.378 172.421 85.3843L170.591 85.4162L167.462 84.4793C167.263 84.4213 167.052 84.4237 166.854 84.4861C166.657 84.5485 166.483 84.6682 166.353 84.8299L166.239 84.9764L169.119 86.2511L166.245 87.309L163.192 85.7603C163.072 85.6987 162.934 85.6814 162.802 85.7118C162.67 85.7421 162.553 85.818 162.472 85.926C162.379 86.0462 162.338 86.1981 162.357 86.3486C162.376 86.4991 162.454 86.6359 162.574 86.7291L166.844 90.024C166.978 90.1281 167.132 90.2023 167.297 90.2419C167.462 90.2815 167.633 90.2854 167.8 90.2535L172.522 89.3039L173.842 90.7442L176.155 89.5524Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209.08 83.0135L191.572 101.324L174.862 87.819L172.555 89.4951L190.941 110.329L206.881 101.744L209.08 83.0135Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.273 87.6915L244.451 115.893L236.535 116.122L228.664 102.885C228.664 102.885 233.087 89.5334 235.273 87.6915Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.287 82.8478L235.273 87.7233L226.912 111.107L227.9 117.626L204.484 117.665L207.276 107.162L205.364 100.432C205.116 99.5582 205.102 98.6348 205.326 97.7548L209.073 83.0454L218.913 81.4648L225.287 82.8478Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.81 81.4776C224.81 81.4776 226.772 82.8032 226.836 83.9822C226.868 84.6769 226.836 85.8942 226.772 86.8247C226.737 87.5517 226.571 88.2664 226.282 88.9342L222.745 93.2043L218.653 89.9731L215.256 91.7066C215.256 91.7066 214.619 86.4997 216.104 82.8669C217.589 79.2342 224.051 80.5662 224.81 81.4776Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M227.62 71.3762C227.62 71.3762 226.817 74.2632 226.441 76.1752C226.065 78.0872 225.306 81.9111 225.376 83.3451C225.447 84.779 219.411 90.8846 218.653 89.9732C217.894 89.0618 217.098 83.7657 217.098 83.7657L217.85 75.2001C217.85 75.2001 225.714 66.4879 227.62 71.3762Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M215.006 66.9149C215.006 66.9149 213.929 68.693 213.929 69.4642C213.929 70.2353 214.305 71.7458 214.242 72.1855C214.178 72.6253 213.107 74.0975 212.967 74.5946C212.896 74.7969 212.902 75.0179 212.983 75.2162C213.064 75.4145 213.215 75.5765 213.407 75.6717C213.667 75.805 213.92 75.9517 214.165 76.1114C214.165 76.1114 214.484 80.0373 214.994 81.0507C215.503 82.064 215.943 82.5101 217.46 82.6376C218.977 82.765 222.59 81.1781 223.094 79.9098C223.597 78.6416 223.667 77.1248 223.731 75.2893C223.795 73.4538 222.527 70.828 221.577 68.3233C220.627 65.8187 216.651 64.4421 215.006 66.9149Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M231.354 79.878C234.04 79.878 236.217 77.7009 236.217 75.0152C236.217 72.3296 234.04 70.1525 231.354 70.1525C228.668 70.1525 226.491 72.3296 226.491 75.0152C226.491 77.7009 228.668 79.878 231.354 79.878Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M214.98 66.6408C214.98 66.6408 216.937 64.9519 220.455 68.3106C223.973 71.6693 222.635 76.5257 224.986 77.5327C227.338 78.5396 231.691 73.5048 232.195 70.9937C232.698 68.4827 231.188 63.2758 226.491 62.2688C221.793 61.2619 216.038 61.9502 214.98 66.6408Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M214.981 66.6406C214.94 66.2456 214.988 65.8464 215.124 65.4732C215.26 65.0999 215.479 64.7626 215.765 64.4867C216.05 64.2108 216.395 64.0037 216.773 63.8811C217.151 63.7585 217.552 63.7236 217.945 63.779C221.131 63.9511 221.463 68.9796 223.139 70.9935C224.815 73.0074 225.656 72.6697 225.656 72.6697C225.656 72.6697 222.808 73.5046 220.959 72.4976C219.111 71.4906 218.219 65.8121 214.981 66.6406Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M220.188 63.1929C221.865 64.2286 223.196 65.7393 224.012 67.533C225.459 70.5985 225.459 73.1287 228.894 72.9503C228.894 72.9503 227.269 73.3135 224.738 72.0453C222.208 70.777 221.667 67.1698 220.041 65.723C219.155 64.8839 218.008 64.3734 216.791 64.2763",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M232.195 70.9937C232.195 70.9937 232.048 75.5951 228.518 76.5638",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M222.341 75.6906C222.341 75.6906 225.706 71.2867 226.496 74.5753C227.287 77.8638 224.584 78.6669 223.31 78.2908C222.035 77.9148 222.214 77.2329 222.214 77.2329",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M222.341 75.6906C222.341 75.6906 225.706 71.2867 226.496 74.5753C227.287 77.8638 224.584 78.6669 223.31 78.2908C222.035 77.9148 222.214 77.2329 222.214 77.2329",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M214.853 113.375C214.853 113.375 208.429 114.268 207.358 114.268C206.287 114.268 203.61 117.658 203.61 117.658H215.388L214.853 113.375Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M242.144 109.055L244.451 114.255C244.555 114.561 244.584 114.887 244.538 115.207C244.491 115.527 244.37 115.831 244.184 116.095C243.997 116.359 243.751 116.576 243.466 116.726C243.18 116.877 242.863 116.959 242.539 116.964L214.688 117.123L214.867 113.376L236.459 109.96",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M242.144 109.055L244.451 114.255C244.555 114.561 244.584 114.887 244.538 115.207C244.491 115.527 244.37 115.831 244.184 116.095C243.997 116.359 243.751 116.576 243.466 116.726C243.18 116.877 242.863 116.959 242.539 116.964L214.688 117.123L214.867 113.376L236.459 109.96",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M204.867 180.893L205.001 185.947H204.204L203.14 183.423L204.867 180.893Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M203.44 177.516L202.414 170.161L197.073 170.505L198.921 177.745L196.563 182.468L191.464 185.801C191.464 185.801 190.878 186.387 193.427 186.19C195.977 185.992 201.266 186.19 201.266 186.19L204.6 182.27C204.6 182.27 205.804 180.224 203.44 177.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M201.266 186.164L204.6 182.244C204.6 182.244 205.46 180.785 204.268 178.682C201.897 182.735 198.743 183.952 198.743 183.952L195.46 183.162L191.464 185.775C191.464 185.775 190.878 186.361 193.427 186.164C195.977 185.966 201.266 186.164 201.266 186.164Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200.992 132.431L203.28 171.512L196.033 171.684L188.959 136.179C188.959 136.179 189.093 129.417 191.253 128.639C193.414 127.862 199.15 128.697 199.15 128.697",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M200.992 132.431L203.28 171.512L196.033 171.684L188.959 136.179C188.959 136.179 189.093 129.417 191.253 128.639C193.414 127.862 199.15 128.697 199.15 128.697",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M169.316 48.3114L178.309 73.5175C178.309 73.5175 177.123 79.2215 173.554 78.9857C169.985 78.7499 169.036 73.7533 168.086 73.0395C167.137 72.3257 165.709 66.8575 165.709 66.8575L169.316 48.3114Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M146.054 43.2573L131.434 48.5343L137.042 89.0744H163.421L169.316 48.3113L153.536 43.372L146.054 43.2573Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M147.462 50.204L149.571 53.3842L147.742 80.3557L150.432 87.3789L153.191 80.5469L150.827 53.7857L152.726 49.1906L150.094 45.73L147.462 50.204Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M150.381 48.8911L146.614 51.7144L144.135 44.3533L145.862 40.625L153.567 40.4402L155.447 42.1291L155.071 51.5232L150.381 48.8911Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.364 38.7133L153.778 43.4486L149.559 48.8914L146.404 43.3721V34.4943C146.404 34.4943 151.93 35.8772 154.364 38.7133Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M144.237 28.8728C144.237 24.5709 147.373 21.0847 151.248 21.0847C155.123 21.0847 157.271 24.7621 157.271 29.064C157.271 30.4533 156.984 32.8369 156.869 34.1052C156.671 36.2721 156.015 37.1898 154.734 39.1337C150.534 45.5069 147.086 36.1574 145.321 33.0154C144.606 31.752 144.233 30.3243 144.237 28.8728Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M154.295 30.2239L154.888 34.666L152.804 34.6087",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M154.295 30.2239L154.888 34.666L152.804 34.6087",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M158.947 29.453L148.928 29.4976C148.805 29.8872 148.786 30.3023 148.873 30.7015C148.96 31.1007 149.151 31.4701 149.425 31.7729C150.062 32.4102 152.656 32.1871 153.071 32.0214C153.485 31.8557 153.708 30.033 153.708 30.033H154.454C154.454 30.033 154.536 31.9449 155.607 32.1043C156.678 32.2636 158.074 32.2126 158.341 32.0214C159.527 31.2248 158.947 29.453 158.947 29.453Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145.474 33.7358C145.474 33.7358 147.73 38.3564 148.265 39.956C148.801 41.5557 151.452 42.8049 154.135 41.9126C156.818 41.0204 156.092 37.0499 156.092 37.0499C156.092 37.0499 153.243 34.6153 152.714 35.1379C152.185 35.6605 149.33 37.9867 149.151 37.4514C148.973 36.916 147.73 33.7167 147.73 33.7167L147.15 31.4478L148.342 30.683C148.514 30.5397 148.626 30.337 148.655 30.115C148.685 29.8931 148.63 29.6681 148.501 29.4848L147.94 28.6754C147.871 28.5763 147.822 28.4643 147.797 28.3461C147.772 28.2279 147.771 28.1058 147.794 27.9871C147.94 27.2925 148.342 25.8521 149.272 25.4379C150.547 24.9089 152.096 25.68 153.523 26.0369C154.951 26.3938 156.499 25.1064 156.499 25.1064L157.137 27.2224C158.55 25.8962 159.554 24.1934 160.03 22.315C160.744 19.2877 153.447 18.0449 151.108 18.0449C148.769 18.0449 145.06 19.3196 143.989 22.6719C142.918 26.0242 144.843 33.1367 145.474 33.7358Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M151.248 22.334C151.248 22.334 152.574 24.3224 150.834 24.7367C149.094 25.1509 145.703 23.6596 144.212 24.2396",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M148.265 26.7189C148.265 26.7189 145.538 26.3875 144.441 27.5474",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M154.83 36.7693C154.83 36.7693 152.822 37.8146 151.828 36.5718",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M145.812 32.327C145.812 32.327 143.843 30.1601 143.843 32.5246C143.843 34.889 144.435 34.889 145.615 35.7112C146.794 36.5333 147.195 35.5136 147.195 35.5136",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M145.812 32.327C145.812 32.327 143.843 30.1601 143.843 32.5246C143.843 34.889 144.435 34.889 145.615 35.7112C146.794 36.5333 147.195 35.5136 147.195 35.5136",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M172.107 179.236H172.196L172.024 178.369L163.42 89.0807H137.041L128.367 179.23H128.463L134.058 179.708C134.058 179.708 140.266 158.867 140.266 157.312C140.266 155.757 142.038 141.379 142.038 141.379L150.839 110.437L158.621 141.379C158.621 141.379 160.393 155.789 160.393 157.312C160.393 158.836 166.606 179.721 166.606 179.721L171.871 179.268H172.107V179.236Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M161.452 94.3322L155.582 102.713",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M158.31 96.2185L154.747 102.088",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M141.548 95.8046L146.78 101.458",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M141.127 97.895L148.666 105.441",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138.609 89.9348H161.872",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M128.464 179.23C128.464 179.23 125.105 181.875 123.168 182.601C121.23 183.328 117.61 185.259 117.61 185.259C117.61 185.259 117.61 186.47 120.752 186.47H133.085L132.874 179.23H128.464Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M133.039 185.15C128.115 185.375 123.181 185.297 118.266 184.915L117.629 185.259C117.629 185.259 117.629 186.47 120.771 186.47H133.103L133.039 185.15Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M171.597 179.23C171.597 179.23 174.962 181.875 176.893 182.601C178.824 183.328 182.457 185.259 182.457 185.259C182.457 185.259 182.457 186.47 179.308 186.47H166.982L167.205 179.23H171.597Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M167.021 185.15C171.945 185.375 176.879 185.297 181.794 184.915L182.431 185.259C182.431 185.259 182.431 186.47 179.283 186.47H166.982L167.021 185.15Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M131.433 48.5345L121.721 74.4672H131.038L134.518 67.3929L131.433 48.5345Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.924 70.4517C170.036 68.8457 157.564 68.049 156.913 68.049C156.263 68.049 135.99 66.3792 134.327 66.137C132.663 65.8949 130.758 69.7061 130.758 69.7061L139.553 69.4639L150.253 71.6053C150.253 71.6053 171.922 79.4507 173.554 78.9791C173.776 78.905 173.978 78.7781 174.14 78.6094",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M173.924 70.4517C170.036 68.8457 157.564 68.049 156.913 68.049C156.263 68.049 135.99 66.3792 134.327 66.137C132.663 65.8949 130.758 69.7061 130.758 69.7061L139.553 69.4639L150.253 71.6053C150.253 71.6053 171.922 79.4507 173.554 78.9791C173.776 78.905 173.978 78.7781 174.14 78.6094",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M128.617 69.2348L162.14 65.908L162.382 68.7568L133.371 77.5582C133.371 77.5582 128.145 78.7436 124.098 78.0298C120.051 77.316 121.963 73.2754 122.913 70.8982",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M128.617 69.2348L162.14 65.908L162.382 68.7568L133.371 77.5582C133.371 77.5582 128.145 78.7436 124.098 78.0298C120.051 77.316 121.963 73.2754 122.913 70.8982",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M162.146 65.9077L168.563 65.6655L170.463 69.4703L162.381 68.7629L162.146 65.9077Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M204.892 121.826L210.366 187.005C210.381 187.102 210.415 187.196 210.466 187.279C210.518 187.362 210.586 187.434 210.667 187.491C210.748 187.547 210.839 187.586 210.935 187.605C211.031 187.625 211.13 187.625 211.227 187.604C211.391 187.564 211.534 187.465 211.632 187.327C211.729 187.189 211.773 187.02 211.756 186.852L208.027 121.846L204.892 121.826Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M241.685 121.826L247.178 187.222C247.192 187.319 247.225 187.413 247.277 187.497C247.328 187.581 247.397 187.653 247.477 187.71C247.558 187.766 247.65 187.805 247.746 187.824C247.843 187.843 247.942 187.842 248.039 187.821C248.203 187.78 248.346 187.682 248.444 187.544C248.541 187.406 248.585 187.237 248.568 187.069L244.827 121.826H241.685Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8491 121.826L86.9875 186.438C86.9716 186.608 87.0169 186.777 87.115 186.916C87.2132 187.055 87.3578 187.155 87.5228 187.196C87.6175 187.221 87.7163 187.225 87.8125 187.207C87.9087 187.19 88.0001 187.152 88.0805 187.097C88.1609 187.041 88.2284 186.969 88.2784 186.885C88.3284 186.801 88.3598 186.707 88.3705 186.61L93.0038 121.826H89.8491Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9359 121.826L53.0552 186.196C53.041 186.366 53.0877 186.535 53.1869 186.674C53.2861 186.813 53.4314 186.912 53.597 186.954C53.6916 186.977 53.7901 186.98 53.8859 186.963C53.9817 186.945 54.0727 186.907 54.1528 186.852C54.2329 186.796 54.3004 186.724 54.3507 186.641C54.401 186.558 54.433 186.464 54.4446 186.368L59.0588 121.801L55.9359 121.826Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M248.848 118.213H53.8975V123.808H248.848V118.213Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M248.848 118.213H53.8975V120.131H248.848V118.213Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M248.841 118.213H200.061V123.808H248.841V118.213Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M250.581 116.352H52.1572V118.487H250.581V116.352Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M250.575 116.352H202.094V118.487H250.575V116.352Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3564 116.161H122.984C123.085 116.161 123.185 116.132 123.27 116.077C123.355 116.021 123.422 115.942 123.462 115.848L130.836 99.0357C130.869 98.9569 130.883 98.8709 130.875 98.7854C130.868 98.7 130.839 98.6178 130.791 98.5463C130.744 98.4748 130.679 98.4163 130.604 98.376C130.528 98.3357 130.443 98.3149 130.358 98.3156H103.73C103.63 98.3155 103.533 98.3444 103.449 98.3987C103.365 98.453 103.299 98.5304 103.259 98.6215L95.9103 115.434C95.876 115.511 95.8609 115.595 95.8663 115.678C95.8718 115.762 95.8976 115.843 95.9415 115.915C95.9855 115.987 96.0463 116.046 96.1186 116.089C96.1909 116.132 96.2725 116.156 96.3564 116.161Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8549 114.847H121.575C121.66 114.847 121.744 114.823 121.815 114.776C121.886 114.73 121.942 114.664 121.977 114.586L128.267 100.24C128.301 100.172 128.317 100.097 128.314 100.021C128.31 99.9456 128.287 99.8721 128.247 99.808C128.206 99.7439 128.15 99.6913 128.083 99.6553C128.016 99.6194 127.942 99.6013 127.866 99.6027H105.145C105.058 99.6021 104.973 99.6272 104.901 99.6748C104.828 99.7225 104.771 99.7905 104.737 99.8704L98.4597 114.229C98.4302 114.296 98.4176 114.368 98.4231 114.441C98.4286 114.513 98.452 114.583 98.4911 114.645C98.5302 114.706 98.584 114.756 98.6474 114.792C98.7109 114.827 98.7822 114.846 98.8549 114.847Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M123.352 115.045H83.3477V116.352H123.352V115.045Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M123.36 115.045H103.966V116.352H123.36V115.045Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M136.207 105.951H129.152V116.377H136.207V105.951Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M135.895 114.956H135.156C135.002 114.956 134.854 114.895 134.745 114.786C134.637 114.677 134.576 114.53 134.576 114.376C134.576 114.222 134.637 114.074 134.745 113.966C134.854 113.857 135.002 113.796 135.156 113.796H135.895C136.187 113.794 136.466 113.677 136.673 113.471C136.879 113.265 136.996 112.985 136.997 112.693V110.144C136.996 109.852 136.879 109.573 136.673 109.366C136.466 109.16 136.187 109.043 135.895 109.041H134.945C134.869 109.041 134.794 109.026 134.723 108.997C134.653 108.968 134.589 108.925 134.535 108.872C134.481 108.818 134.439 108.754 134.409 108.683C134.38 108.613 134.365 108.538 134.365 108.461C134.365 108.385 134.38 108.31 134.409 108.239C134.439 108.169 134.481 108.105 134.535 108.051C134.589 107.997 134.653 107.955 134.723 107.926C134.794 107.896 134.869 107.881 134.945 107.881H135.895C136.192 107.881 136.486 107.94 136.761 108.054C137.035 108.167 137.285 108.334 137.495 108.544C137.705 108.754 137.871 109.004 137.985 109.278C138.099 109.553 138.157 109.847 138.157 110.144V112.693C138.157 112.99 138.099 113.285 137.985 113.559C137.871 113.834 137.705 114.083 137.495 114.293C137.285 114.503 137.035 114.67 136.761 114.784C136.486 114.897 136.192 114.956 135.895 114.956Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M191.329 116.161H164.702C164.601 116.16 164.503 116.13 164.419 116.075C164.336 116.019 164.27 115.941 164.23 115.848L156.856 99.0357C156.823 98.9574 156.809 98.872 156.816 98.787C156.824 98.7021 156.852 98.6203 156.899 98.549C156.946 98.4776 157.009 98.419 157.084 98.3783C157.159 98.3375 157.243 98.316 157.328 98.3156H183.955C184.056 98.3151 184.155 98.3437 184.239 98.398C184.324 98.4522 184.392 98.5299 184.433 98.6215L191.807 115.434C191.841 115.513 191.854 115.6 191.846 115.685C191.839 115.771 191.81 115.853 191.763 115.925C191.715 115.997 191.651 116.056 191.575 116.097C191.5 116.138 191.415 116.16 191.329 116.161Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M164.332 116.352H204.337V115.045H164.332V116.352Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M164.333 116.352H191.916V115.045H164.333V116.352Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M174.771 105.294C174.915 105.567 174.976 105.876 174.945 106.183C174.914 106.491 174.794 106.782 174.598 107.021C174.402 107.259 174.141 107.435 173.845 107.526C173.55 107.616 173.235 107.618 172.939 107.53C172.643 107.442 172.38 107.269 172.182 107.032C171.984 106.795 171.86 106.505 171.827 106.198C171.793 105.891 171.851 105.581 171.992 105.307C172.134 105.033 172.354 104.807 172.623 104.657C172.993 104.457 173.426 104.412 173.829 104.532C174.231 104.651 174.57 104.925 174.771 105.294Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2582 55.806L52.2212 75.1997L61.1437 101.03L58.0909 102.777L47.6133 79.132L42.3809 58.8333C42.3809 58.8333 41.9412 52.7277 44.1272 51.8227C46.3132 50.9178 49.3851 51.8801 50.2582 55.806Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M61.169 101.056C61.169 101.056 63.1319 105.205 63.355 106.295C63.5781 107.385 63.8011 109.609 62.9407 110.603C61.9019 111.801 60.9523 110.877 60.9523 110.877C60.9523 110.877 58.3329 110.24 58.3329 108.041C58.3329 105.842 58.1162 102.802 58.1162 102.802L61.169 101.056Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0273 107.563L62.7047 108.519",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9067 105.084L60.9519 106.728C60.9519 106.728 58.5173 110.89 59.8238 109.8C61.1304 108.71 63.5713 107.385 63.3546 106.295C62.9855 105.151 62.4985 104.049 61.9015 103.006",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9067 105.084L60.9519 106.728C60.9519 106.728 58.5173 110.89 59.8238 109.8C61.1304 108.71 63.5713 107.385 63.3546 106.295C62.9855 105.151 62.4985 104.049 61.9015 103.006",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8253 32.4993C39.8253 32.4993 37.5819 30.0775 32.4069 31.6325C27.2318 33.1876 26.0337 41.4728 26.193 45.609C26.3523 49.7452 30.3356 54.4104 29.131 56.4817C27.9265 58.553 23.4334 63.3839 23.7775 68.5908C24.1217 73.7977 28.4364 77.9085 34.6502 76.0092C40.8641 74.11 39.8253 66.5068 38.5889 63.728C37.3525 60.9493 39.9719 59.7575 40.8323 53.7157C41.6926 47.6739 36.1734 42.6709 36.1734 38.3563C36.1734 34.0416 40.6347 34.7363 40.6347 34.7363L39.8253 32.4993Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0502 48.8785C32.8659 50.5611 33.8155 52.3583 34.7588 54.2958C37.9072 60.72 35.4471 63.0398 30.6608 66.5961C25.8745 70.1523 26.9707 74.5244 28.2007 75.1999",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1806 34.201C38.1806 34.201 31.7564 34.7492 30.1121 38.8471C29.1179 41.3391 29.8827 44.1305 31.3485 47.3809",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4844 73.6003C33.9786 73.7861 34.5057 73.8685 35.0331 73.8425",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8246 33.7738C39.8246 33.7738 33.8083 34.8636 32.4444 39.2357C31.0806 43.6077 39.1427 50.0701 39.5506 54.8245C39.9585 59.579 34.2162 62.3577 32.1768 66.0478C30.7428 68.6353 30.9021 71.4841 32.4126 72.9181",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2614 121.769C55.2614 121.769 53.7765 134.592 52.2851 138.684C50.7938 142.775 47.4543 174.928 47.2694 176.789C47.0846 178.65 52.1003 182.92 54.1461 184.227C56.1919 185.533 55.2614 185.896 53.0308 186.081C50.8002 186.266 48.1999 185.896 47.0846 183.851C45.9693 181.805 43.3626 181.25 43.3626 181.25L42.993 185.712H42.2473L41.6929 180.135C41.5033 178.869 41.6964 177.575 42.2473 176.419C43.1778 174.374 43.522 170.097 43.522 164.31C43.522 158.523 42.4067 149.25 42.9611 144.789C43.5156 140.328 45.7526 136.982 45.7526 133.266C45.7526 129.551 45.9374 123.974 45.9374 123.974L55.2614 121.769Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6931 180.135C41.5451 179.176 41.6259 178.195 41.929 177.273C43.0825 179.224 46.3902 181.868 48.9395 182.92C50.3217 183.518 51.8286 183.772 53.3306 183.659C53.6302 183.882 53.9106 184.074 54.1464 184.226C56.1922 185.501 55.2617 185.896 53.0311 186.081C50.8005 186.266 48.2002 185.896 47.0849 183.85C45.9696 181.805 43.3629 181.25 43.3629 181.25L42.9933 185.711H42.2476L41.6931 180.135Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4775 123.815C44.4775 123.815 41.2909 133.292 38.3464 141.468C35.402 149.645 28.3086 168.421 27.5629 171.767C26.8173 175.113 26.4476 181.25 24.3763 184.411C22.305 187.572 20.2847 189.057 20.6544 183.481C21.024 177.904 24.3763 173.812 25.1156 169.536C25.8549 165.26 26.2309 149.836 28.8312 142.96C31.4315 136.083 34.223 130.506 34.5671 128.461C34.8213 126.425 34.9447 124.375 34.9368 122.323L44.4775 123.815Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0372 181.091C21.0647 182.142 21.3919 183.163 21.9804 184.035C23.0511 185.233 24.7783 182.907 25.6769 181.486C25.3829 182.511 24.9543 183.492 24.4023 184.405C22.3565 187.559 20.3106 189.051 20.6803 183.474C20.7418 182.672 20.8611 181.875 21.0372 181.091Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M43.012 49.0059C43.012 49.0059 41.8967 49.9364 41.151 56.2586C40.4054 62.5808 45.0578 82.2804 45.0578 82.2804C45.0578 82.2804 37.0658 95.371 35.2048 101.878C33.3438 108.385 32.2285 132.763 32.2285 132.763C32.2285 132.763 36.1353 134.254 44.1273 134.808C52.1193 135.363 56.3958 133.324 56.3958 133.324C56.3958 133.324 56.7654 98.5321 56.7654 93.1722C56.7654 87.8124 57.1414 75.6204 57.6959 74.1355C58.2504 72.6505 59.9265 68.7437 59.9265 67.2587C59.9265 65.7738 48.7479 49.9364 48.7479 49.9364L43.012 49.0059Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1843 101.878C36.6501 96.7796 42.7174 83.2174 44.8843 80.8848C48.1793 81.981 54.1892 83.0644 56.8723 82.2614C56.7895 84.1733 56.7449 91.3113 56.7449 93.1405C56.7449 98.5322 56.3752 133.292 56.3752 133.292C56.3752 133.292 52.0988 135.338 44.1068 134.777C36.1148 134.216 32.208 132.731 32.208 132.731C32.208 132.731 33.3233 108.385 35.1843 101.878Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1357 27.0948C47.1357 27.0948 49.1306 22.7483 53.0756 22.7483C57.0206 22.7483 58.7732 26.2536 57.9001 29.3191C57.027 32.3846 60.5259 31.5115 60.9656 33.4872C61.4054 35.4629 58.1168 36.7694 56.3642 36.7694C54.6115 36.7694 47.1357 27.0948 47.1357 27.0948Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8965 26.6485C54.0692 26.0112 55.4458 25.5523 56.0831 26.5466C57.3131 28.4585 53.4892 29.9626 54.7192 32.0148C55.9493 34.067 58.9574 33.5189 58.8172 34.2008C58.677 34.8827 56.7714 35.2906 56.7714 35.2906",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8896 28.0382C50.8896 28.0382 51.2657 27.7131 51.8265 27.318",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2501 37.2091C56.9711 37.0017 56.7514 36.7248 56.6128 36.406C56.2941 34.0543 55.6058 31.7409 54.3057 30.4407C52.3389 28.5892 49.8305 27.4166 47.1486 27.0948C46.3544 26.9777 45.5438 27.052 44.7841 27.3115C41.3999 28.4969 38.4937 30.8359 39.1183 36.4762C39.8066 42.69 44.6439 44.2451 44.6439 44.2451L44.988 48.069L49.8189 50.3124L49.991 46.1698C49.991 46.1698 53.2668 47.5464 54.4523 47.3743C55.6377 47.2023 56.0073 45.6472 56.5236 43.4038C56.7131 42.3802 56.807 41.3411 56.804 40.3001L58.2507 38.8597C59.0729 38.0248 58.2634 37.8209 57.2501 37.2091Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1056 36.4762C38.4683 30.8359 41.3872 28.4969 44.7714 27.3115C45.5311 27.052 46.3417 26.9777 47.1359 27.0948C48.9643 27.3392 50.7245 27.9505 52.3109 28.892C51.3422 28.6945 52.9928 31.5433 51.476 33.3533C50.1478 35.0335 48.4543 36.3892 46.524 37.3174C46.524 37.3174 44.8033 35.9344 44.2807 37.8336C43.758 39.7329 43.9365 41.1095 45.3195 41.46C46.7025 41.8105 47.2315 41.46 47.2315 41.46C47.2315 41.46 46.3137 43.6333 44.6822 44.5319V44.2196C44.6822 44.2196 39.8258 42.6964 39.1056 36.4762Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2849 49.1909L51.3608 54.213L41.5078 49.0061L42.4383 44.36L52.2849 49.1909Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5239 91.5345C48.5442 91.7527 49.5797 91.8933 50.6213 91.9551C51.4307 91.9041 52.5332 90.9927 53.349 91.3815C54.1648 91.7703 55.3056 94.224 55.3056 94.224C55.3056 94.224 56.389 94.7721 56.0767 95.352C55.7645 95.932 54.4261 96.4673 54.4261 96.4673C54.4261 96.4673 53.1514 97.6719 52.4122 97.793C51.6729 97.9141 47.167 94.6064 47.167 94.6064L47.5239 91.5345Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0028 93.9181C48.152 93.7389 48.2591 93.5286 48.3164 93.3026C48.3737 93.0766 48.3796 92.8406 48.3338 92.612C48.2879 92.3834 48.1915 92.168 48.0515 91.9815C47.9115 91.7951 47.7315 91.6423 47.5248 91.5345L35.1416 79.9353L48.6273 58.9674C49.2291 57.8587 49.3752 56.5593 49.0347 55.3447C48.6942 54.1301 47.8939 53.0959 46.8035 52.4616C45.7132 51.8273 44.4186 51.6428 43.1945 51.9471C41.9703 52.2515 40.9129 53.0208 40.2466 54.0919L28.5581 77.3223C27.9504 77.912 27.599 78.7172 27.5799 79.5638C27.5608 80.4105 27.8756 81.2307 28.4561 81.8472L28.5007 81.8918C29.6734 83.7018 42.5728 93.1661 46.3457 94.4025C46.6388 94.4953 46.9529 94.4989 47.248 94.4126C47.5431 94.3263 47.8058 94.1542 48.0028 93.9181Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0004 61.8162C97.0004 61.8162 98.6 66.7682 98.6 67.7305C98.5883 68.4256 98.5351 69.1194 98.4407 69.8082L99.8492 71.9942C99.9317 72.1348 99.9573 72.3017 99.9205 72.4605C99.8838 72.6194 99.7875 72.7581 99.6516 72.8482L97.4784 74.1228C97.4784 74.1228 97.1597 79.2214 96.841 79.8587C96.5224 80.4961 91.1051 80.3431 91.1051 80.3431L89.3461 83.6954L80.2324 80.1838L82.6288 73.6257L82.1316 63.7281C82.1316 63.7281 87.7273 58.7825 97.0004 61.8162Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7616 73.8616C90.7616 73.8616 89.1746 75.353 87.9828 75.455C86.791 75.5569 82.9161 74.6583 82.6166 74.2632C82.3171 73.868 79.6403 68.3042 79.7359 65.6211C79.8315 62.938 79.9398 58.9674 82.8142 57.6801C85.6885 56.3927 90.2645 56.7814 92.648 55.2965C95.0316 53.8115 98.8046 52.6134 100.793 55.1945C102.781 57.7757 101.29 61.351 99.7032 62.8424C98.1163 64.3337 96.1278 64.7543 96.3254 65.3917C96.5229 66.029 97.7147 66.781 97.0201 67.7752C96.3254 68.7695 93.8335 69.6872 93.8335 70.0568C93.8335 70.4265 94.4325 71.8477 93.7379 72.0453C93.0432 72.2429 92.3421 70.6559 91.6474 70.6559C90.9528 70.6559 89.4742 72.5743 90.7616 73.8616Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6123 69.3048C86.326 69.6251 86.0819 69.9806 85.8857 70.3628",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6642 59.0122C99.5381 60.106 99.1394 61.1507 98.5047 62.0504C97.87 62.9501 97.0196 63.6761 96.0314 64.1618C93.4821 65.481 90.0852 66.5581 87.8291 68.2151",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3258 65.4233C96.3258 65.4233 94.0633 67.3353 91.6415 69.3046C89.9889 70.5838 88.1516 71.6045 86.1924 72.3319",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6016 74.1294L91.8762 74.4481C91.799 75.0439 91.8446 75.6493 92.0101 76.2269C92.1756 76.8045 92.4575 77.3422 92.8386 77.8067",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6016 74.1294L91.8762 74.4481C91.799 75.0439 91.8446 75.6493 92.0101 76.2269C92.1756 76.8045 92.4575 77.3422 92.8386 77.8067",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0811 70.7067L101.08 68.4761",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7666 68.2979L100.819 68.3871C100.819 68.3871 101.526 70.7069 99.3912 70.9746",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6908 178.484C89.6908 178.484 97.9759 183.717 99.4354 183.717C100.895 183.717 101.621 185.03 100.895 185.176C100.168 185.323 95.6561 185.463 92.6097 185.61C89.5633 185.756 87.5111 185.463 85.7712 185.463C84.0313 185.463 81.9855 185.61 81.1124 185.176C80.2393 184.743 81.6987 179.791 81.6987 178.918C81.6987 178.045 88.671 177.898 89.6908 178.484Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M100.372 183.933C97.1539 184.991 91.9343 184.296 88.7986 184.01C86.3195 183.787 82.4254 183.736 80.8385 183.723C80.7748 184.469 80.8385 185.036 81.0871 185.176C81.9602 185.609 83.9996 185.463 85.7459 185.463C87.4921 185.463 89.5252 185.756 92.5843 185.609C95.6435 185.463 100.149 185.316 100.87 185.176C101.437 185.061 101.169 184.309 100.372 183.933Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2368 142.539L89.6979 175.329L91.0617 178.733C90.0829 180.15 88.6062 181.147 86.9255 181.524C85.0566 181.892 83.158 182.088 81.2534 182.111C81.2534 182.111 80.5268 178.471 80.9666 178.032C81.4063 177.592 81.5465 175.852 81.5465 175.852L85.3259 142.826L96.2368 142.539Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M116.165 177.376C116.165 177.376 121.264 181.595 123.59 182.321C125.916 183.048 128.389 183.774 128.389 184.501C128.389 185.227 122.864 185.954 118.644 185.521C114.425 185.087 108.02 183.194 106.567 183.194C105.114 183.194 105.401 179.409 105.401 178.829C105.401 178.249 112.533 173.59 116.165 177.376Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M128.414 184.501C128.414 184.24 128.089 183.978 127.573 183.717C123.408 184.274 119.186 184.244 115.03 183.628C110.843 183.029 107.338 182.226 105.547 181.78C105.7 182.563 105.999 183.194 106.592 183.194C108.045 183.194 114.45 185.106 118.669 185.521C122.888 185.935 128.414 185.227 128.414 184.501Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8573 127.843C95.2198 127.509 99.6046 127.607 103.948 128.136C111.366 129.009 127.943 130.048 128.23 131.922C128.517 133.795 115.369 173.175 115.369 174.189C115.369 175.202 116.529 176.228 116.822 176.808C117.007 177.222 117.106 177.668 117.115 178.121C117.115 178.121 113.552 181.945 110.786 182.984C108.02 184.023 105.688 183.048 105.114 183.048C104.541 183.048 104.534 179.122 104.974 177.229C105.414 175.336 106.134 170.537 106.28 170.104C106.427 169.67 114.394 141.666 114.394 141.666C114.394 141.666 92.7246 145.159 79.7806 143.699C66.8366 142.24 65.5237 140.213 64.7972 137.154C64.0706 134.095 65.5237 127.989 65.5237 127.989L90.8573 127.843Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2188 137.269C88.9247 137.694 88.5965 138.095 88.2373 138.467",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1839 129.443C92.3477 131.537 91.3835 133.578 90.2969 135.554",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4498 130.902C89.6944 133.798 87.0365 136.037 83.8848 137.275",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M124.475 138.932C124.972 138.741 125.45 138.543 125.902 138.339L124.475 138.932Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M124.475 138.932C124.972 138.741 125.45 138.543 125.902 138.339",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M114.394 141.666C117.193 141.126 119.959 140.425 122.679 139.569L114.394 141.666Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M114.394 141.666C117.193 141.126 119.959 140.425 122.679 139.569",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M131.213 93.3511C131.518 92.1338 132.028 92.2294 131.62 91.8279C131.06 91.2671 130.607 91.9299 128.982 92.8412C127.357 93.7526 125.738 94.8679 125.738 94.8679C125.774 94.5297 125.914 94.2111 126.139 93.9566C126.55 93.2846 126.771 92.5135 126.777 91.7259C126.777 91.0886 126.267 91.2161 126.063 91.8279C125.859 92.4397 124.036 93.5487 123.934 94.0585C123.832 94.5684 123.469 96.5696 123.469 96.5696C122.889 97.4427 122.889 101.515 122.889 101.515L111.08 110.387L105.114 117.397C105.114 117.397 107.734 121.616 109.187 121.036C110.64 120.456 111.366 119.87 114.859 116.957C117.816 114.491 125.228 103.115 125.228 103.115C126.519 102.304 127.741 101.387 128.88 100.374C130.194 98.8875 130.971 97.0021 131.085 95.0209C131.058 94.4612 131.101 93.9002 131.213 93.3511Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5685 79.8907C76.5685 79.8907 77.6902 75.6844 82.4574 76.5257C87.2245 77.3669 90.87 81.2928 91.7113 82.6949C92.5525 84.097 76.2881 82.1341 76.2881 82.1341L76.5685 79.8907Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M104.05 116.626C104.05 116.626 102.941 117.824 104.05 119.71C104.808 121.017 106.146 122.018 108.708 121.578C111.105 121.157 114.706 115.205 114.706 111.017C114.706 106.83 111.621 106.556 110.499 107.372C109.378 108.188 104.05 116.626 104.05 116.626Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6327 79.4002C78.6327 79.4002 67.2884 84.7856 65.6887 85.7734C64.0891 86.7613 63.0693 99.444 63.0693 101.63C63.0693 103.816 64.669 125.211 65.1024 128.831C65.5358 132.451 79.5059 134.943 84.1647 133.63C88.8235 132.317 93.3612 129.009 93.3612 127.843C93.3612 126.677 92.9215 116.792 93.2146 114.899C93.5078 113.006 96.1208 105.008 96.1208 105.008L104.062 117.678C104.062 117.678 104.897 119.233 107.848 118.009C112.067 116.263 112.417 109.514 112.417 109.514C112.417 109.514 107.765 101.369 106.452 97.2962C105.139 93.2237 104.54 90.1646 103.979 89.438C103.418 88.7115 90.3021 82.5996 87.9759 80.9999C86.6588 80.0079 85.1236 79.3451 83.4983 79.0668C81.8731 78.7885 80.2048 78.9029 78.6327 79.4002Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0899 105.007L92.3105 99.4755",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4774 104.217L88.8174 100.935",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7402 145.943L81.5526 187.254C81.566 187.349 81.5992 187.441 81.6501 187.524C81.701 187.606 81.7685 187.676 81.8483 187.731C81.9281 187.786 82.0184 187.823 82.1134 187.841C82.2085 187.858 82.3062 187.856 82.4002 187.834C82.5636 187.793 82.7072 187.696 82.8053 187.559C82.9034 187.423 82.9496 187.256 82.9356 187.088L78.8376 145.261L75.7402 145.943Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0419 146.268L49.3291 186.84C49.3069 186.934 49.3046 187.031 49.3223 187.126C49.34 187.222 49.3773 187.312 49.4319 187.392C49.4865 187.471 49.5571 187.539 49.6393 187.59C49.7215 187.641 49.8134 187.674 49.9091 187.687C50.0753 187.712 50.2448 187.675 50.3857 187.584C50.5265 187.492 50.6291 187.352 50.6739 187.19L61.9545 147.817L59.0419 146.268Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M76.683 145.764L70.501 187.018C70.4867 187.113 70.4921 187.21 70.5169 187.303C70.5417 187.396 70.5853 187.483 70.6451 187.558C70.7049 187.633 70.7795 187.695 70.8643 187.741C70.9492 187.786 71.0424 187.813 71.1383 187.821C71.3058 187.83 71.471 187.778 71.6034 187.675C71.7358 187.572 71.8264 187.425 71.8584 187.26L79.7039 147.058L76.683 145.764Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5693 145.943L104.382 187.254C104.395 187.35 104.428 187.442 104.479 187.524C104.53 187.606 104.598 187.677 104.677 187.731C104.757 187.786 104.848 187.823 104.943 187.841C105.038 187.858 105.135 187.856 105.229 187.834C105.393 187.794 105.536 187.696 105.634 187.56C105.732 187.423 105.779 187.256 105.765 187.088L101.648 145.248L98.5693 145.943Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8467 103.07L56.921 149.066H107.231C107.231 149.066 107.977 135.809 105.759 131.125C103.541 126.441 76.1553 136.485 75.1675 136.223C74.4346 136.039 75.518 112.292 76.8628 103.013C76.9569 102.359 76.9095 101.694 76.7236 101.06C76.5378 100.427 76.2179 99.8413 75.7857 99.3426C75.3534 98.8439 74.819 98.444 74.2186 98.17C73.6182 97.896 72.9659 97.7544 72.3059 97.7548H54.3972C53.7322 97.7541 53.0749 97.8976 52.4706 98.1753C51.8664 98.4531 51.3295 98.8585 50.897 99.3637C50.4645 99.8689 50.1467 100.462 49.9653 101.102C49.784 101.742 49.7436 102.413 49.8467 103.07Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M105.758 131.125C103.54 126.441 76.1545 136.485 75.1666 136.224C74.4337 136.039 75.5172 112.292 76.8619 103.013C76.9795 102.368 76.9534 101.705 76.7857 101.071C76.618 100.438 76.3126 99.8487 75.8914 99.3464C75.4702 98.8441 74.9435 98.4408 74.3487 98.1652C73.754 97.8896 73.1058 97.7484 72.4503 97.7518C71.7948 97.7551 71.148 97.9029 70.5561 98.1845C69.9642 98.4662 69.4416 98.8748 69.0255 99.3814C68.6095 99.8879 68.3101 100.48 68.1489 101.115C67.9876 101.751 67.9683 102.414 68.0924 103.057L75.1666 149.053H107.23C107.23 149.053 107.976 135.809 105.758 131.125Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M131.212 93.3508C131.212 93.3508 130.403 94.1602 129.186 95.5815L131.212 93.3508Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M131.212 93.3508C131.212 93.3508 130.403 94.1602 129.186 95.5815",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M131.085 94.9952C131.085 94.9952 130.098 97.0028 129.492 97.9142L131.085 94.9952Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M131.085 94.9952C131.085 94.9952 130.098 97.0028 129.492 97.9142",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M260.931 185.826H1.7002V189H260.931V185.826Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMeeting);
export default __webpack_public_path__ + "static/media/teamMeeting.298b304fae8697ff48be1cd5de0c1e09.svg";
export { ForwardRef as ReactComponent };